<template>
  <div>
    <a-form layout="inline" :form="form" @submit="handleSubmit">
      <a-form-item
        has-feedback
        :validate-status="form.getFieldValue('Format') ? 'success' : 'error'"
      >
        <a-select
          style="width: 200px"
          v-decorator="['Format', { rules: [{ required: false }] }]"
          :placeholder='$t("Format")'
        >
          <a-select-option value="Comarch Optima"
            >Comarch Optima</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item
        has-feedback
        :validate-status="form.getFieldValue('Type') ? 'success' : 'error'"
      >
        <a-select
          style="width: 200px"
          v-decorator="['Type', { rules: [{ required: false }] }]"
          :placeholder='$t("Zakres danych")'
        >
          <a-select-option value="Wszystkie faktury"
            >{{$t("Wszystkie faktury")}}</a-select-option
          >
          <a-select-option value="Faktury sprzedazowe"
            >{{$t("Faktury sprzedazowe")}}</a-select-option
          >
          <a-select-option value="Faktury kosztowe"
            >{{$t("Faktury kosztowe")}}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item
        has-feedback
        :validate-status="form.getFieldValue('Company') ? 'success' : 'error'"
      >
        <a-select
          style="width: 200px"
          v-decorator="['Company', { rules: [{ required: false }] }]"
          :placeholder='$t("Company")'
        >
          <a-select-option v-for="(comp, id) in MY_COMPANY_LIST" :key="id">{{
            comp["TITLE"]
          }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        has-feedback
        :validate-status="form.getFieldValue('Dates') ? 'success' : 'error'"
      >
        <a-range-picker
          v-decorator="[
            'Dates',
            {
              rules: [{ type: 'array', required: false }],
              initialValue: [moment(), moment()],
            },
          ]"
        />
      </a-form-item>
      <a-form-item>
        <a-button
          type="primary"
          html-type="submit"
          :disabled="!hasErrors(form.getFieldsValue())"
          >{{ $t("Export") }}</a-button
        >
      </a-form-item>
    </a-form>
    <a-table
      :columns="columns"
      :data-source="fileList"
      bordered
      size="middle"
      @expand="handlerExpand"
      :pagination="{
        'show-size-changer': true,
        showTotal: (total) =>
          `${this.$t('Total')} ${total}`,
      }"
    >
      <template slot="creator" slot-scope="text">{{
        USER_LIST[text]
          ? `${USER_LIST[text]["NAME"]} ${USER_LIST[text]["LAST_NAME"]}`
          : ""
      }}</template>
      <template slot="operation" slot-scope="text, record, index">
        <a-popconfirm
          :title="$t('Delete file?')"
          :ok-text="$t('Yes')"
          :cancel-text="$t('No')"
          @confirm="handleDeleteFile(record, index)"
        >
          <a-button type="link">
            <a-icon type="delete" style="color: #ff4d4f" />
          </a-button>
        </a-popconfirm>
      </template>

      <template slot="expandedRowRender" slot-scope="text">
        <a-table
          :columns="innerColumnsHistory"
          :data-source="text.innerDataHistory"
          :loading="text.loading"
          :pagination="false"
          style="margin-bottom: 25px"
        >
          <template slot="fileName" slot-scope="text, record">
            <a :href="record.DOWNLOAD_URL" download>{{ text }}</a>
          </template>
        </a-table>
        <a-table
          :columns="innerColumns"
          :data-source="text.innerData"
          :pagination="false"
          :loading="text.loading"
        >
          <a slot="id" slot-scope="text">{{ text }}</a>
          <a slot="number" slot-scope="text">{{ text }}</a>
        </a-table>
      </template>
    </a-table>
  </div>
</template>
<script>
import moment from "moment";
import {
  getExportTable,
  sendExportReport,
  getExportTableExpandRow,
  deleteExportReport,
} from "@/requestFunc";
var parseXmlToJson = require("xml2js").parseString;
export default {
  props: ["MY_COMPANY_LIST", "COMPANY_LIST", "USER_LIST"],
  data() {
    const columns = [
      { title: this.$t("Name"), dataIndex: "name", key: "name" },
      { title: this.$t("Date from"), dataIndex: "dateFrom", key: "dateFrom" },
      { title: this.$t("Date to"), dataIndex: "dateTo", key: "dateTo" },
      {
        title: this.$t("CompanyName"),
        dataIndex: "company",
        key: "company",
        customRender: (text) => {
          if (text && this.COMPANY_LIST[text]) {
            return (
              <a
                href={`https://${this.domain}/crm/company/details/${text}/`}
                target="_blank"
              >
                {this.COMPANY_LIST[text]["TITLE"]}
              </a>
            );
          }
          return "";
        },
      },
      {
        title: this.$t("Creator"),
        dataIndex: "creator",
        key: "creator",
        scopedSlots: { customRender: "creator" },
      },
      {
        title: this.$t("Date create"),
        dataIndex: "dateCreate",
        key: "dateCreate",
      },
      {
        title: this.$t("Op."),
        key: "operation",
       // width: 20,
        scopedSlots: { customRender: "operation" },
      },
    ];
    const innerColumnsHistory = [
      {
        title: this.$t("File name"),
        dataIndex: "fileName",
        key: "fileName",
        scopedSlots: { customRender: "fileName" },
      },
      { title: this.$t("Size"), dataIndex: "size", key: "size" },
      { title: this.$t("Creator"), dataIndex: "creator", key: "creator" },
      {
        title: this.$t("Downloaded by"),
        dataIndex: "downloadedBy",
        key: "downloadedBy",
      },
      {
        title: this.$t("Date of download"),
        dataIndex: "dateDownload",
        key: "dateDownload",
      },
    ];
    const innerColumns = [
      // {
      //   title: "Id",
      //   dataIndex: "id",
      //   key: "id",
      // },
      {
        title: this.$t("Number"),
        dataIndex: "number",
        key: "number",
      },
      {
        title: this.$t("Contractor"),
        dataIndex: "contractor",
        key: "contractor",
      },
      { title: this.$t("Netto"), dataIndex: "netto", key: "netto" },
      { title: this.$t("Vat"), dataIndex: "vat", key: "vat" },
      { title: this.$t("Brutto"), dataIndex: "brutto", key: "brutto" },
      { title: this.$t("Currency"), dataIndex: "currency", key: "currency" },
      { title: this.$t("Released"), dataIndex: "released", key: "released" },
      { title: this.$t("Term"), dataIndex: "term", key: "term" },
    ];
    return {
      form: this.$form.createForm(this, { name: "export_form" }),
      fileList: [],
      columns,
      innerColumns,
      innerColumnsHistory,
    };
  },
  methods: {
    moment,
    niceBytes(x) {
      const units = ["bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
      let l = 0,
        n = parseInt(x, 10) || 0;
      while (n >= 1024 && ++l) {
        n /= 1024;
      }
      return n.toFixed(n < 10 && l > 0 ? 1 : 0) + " " + units[l];
    },
    async handlerExpand(expanded, record) {
      let index = this.fileList.findIndex((x) => x.key == record.key);
      this.fileList[index].loading = true;
      if (expanded && record.innerDataHistory.length == 0) {
        let respGetExportTableExpandRow = await getExportTableExpandRow(
          record.fileID
        );
        if (respGetExportTableExpandRow.ok) {
          let result = await respGetExportTableExpandRow.json();

          this.setInnerHistory(index, result.file);
          this.xmlLoad(index, result.file.DOWNLOAD_URL);
        }
      }
      setTimeout(() => {
        this.fileList[index].loading = false;
        this.resizeFrame();
      }, 10);
    },
    xmlLoad(index, url) {
      var xhttp = new XMLHttpRequest();
      xhttp.open("GET", url, false);
      xhttp.send();
      try {
        if (xhttp.status != 200) {
          console.error(`Ошибка ${xhttp.status}: ${xhttp.statusText}`);
        } else {
          parseXmlToJson(xhttp.response, (err, xmlObject) => {
            if (!err) {

              if (
                xmlObject?.ROOT?.REJESTRY_SPRZEDAZY_VAT &&
                xmlObject.ROOT.REJESTRY_SPRZEDAZY_VAT[0]?.REJESTR_SPRZEDAZY_VAT
              ) {
                this.setInnerTable(
                  index,
                  xmlObject.ROOT.REJESTRY_SPRZEDAZY_VAT[0].REJESTR_SPRZEDAZY_VAT
                );
              }
              if (
                xmlObject?.ROOT?.REJESTRY_ZAKUPU_VAT &&
                xmlObject.ROOT.REJESTRY_ZAKUPU_VAT[0]?.REJESTR_ZAKUPU_VAT
              ) {
                this.setInnerTable(
                  index,
                  xmlObject.ROOT.REJESTRY_ZAKUPU_VAT[0].REJESTR_ZAKUPU_VAT
                );
              }

            } else {
              console.error(err);
            }
          });
        }
      } catch (err) {
        console.trace(err, "Wtf");
      }
    },
    setInnerTable(index, xmlData) {
      for (let i in xmlData) {
        this.addInnerData(index, xmlData[i]);
      }
    },
    async handleDeleteFile(record, index) {
      let respDeleteExportReport = await deleteExportReport(record.fileID);
      if (respDeleteExportReport.ok) {
        await respDeleteExportReport.json();

        this.fileList.splice(index, 1);
        this.$notification.success({
          message: this.$t("File deleted"),
          description: `${record.name} (${record.dateFrom} / ${record.dateTo})`,
        });
        setTimeout(this.resizeFrame, 10);
      } else {
        this.$notification.error({
          message: this.$t("File deleted"),
          description: `${record.name}(${record.dateFrom} / ${record.dateTo})`,
        });
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.changeSpinning(true);
          values.Dates = [
            values.Dates[0].format("YYYY-MM-DD"),
            values.Dates[1].format("YYYY-MM-DD"),
          ];
          sendExportReport(values)
            .done((data) => {
              let res = JSON.parse(data);

              this.setFileList(res.file);
              this.$message.success(this.$t("Export completed"));
            })
            .fail((e) => {
              console.err(e);
              this.$message.error(this.$t("Error create export"));
            })
            .always(() => {
              this.changeSpinning(false);
              setTimeout(this.resizeFrame, 10);
            });
        } else {
          this.$notification.success({
            message: this.$t("Export fields error"),
          });
        }
      });
    },
    hasErrors(fields) {
      return !!(
        fields.Company &&
        fields.Type &&
        fields.Format &&
        fields.Dates &&
        fields.Dates.length
      );
    },
    changeSpinning(val) {
      this.$emit("changeSpinning", val);
    },
    resizeFrame() {
      this.$emit("resizeFrame");
    },
    setFileList(files) {
      let list = [];
      //FIXME проверка данных?
      for (let i in files) {
        let file = files[i];
        if (file.title && file.userID && file.company) {
          list.push({
            key: i,
            fileID: file.fileID,
            name: file.title,
            loading: false,
            dateFrom: file.dateFrom,
            dateTo: file.dateTo,
            company: file.company,
            creator: file.userID,
            dateCreate: file.dateCreate,
            innerDataHistory: [],
            innerData: [],
          });
        }
      }
      this.fileList = list;

    },
    setInnerHistory(index, file) {
     /* let creator = `${this.USER_LIST[file.CREATED_BY].NAME} ${
        this.USER_LIST[file.CREATED_BY].LAST_NAME
      }`;*/
      BX24.callMethod('user.get', {"ID": file.CREATED_BY}, 
            (result) => 
            {
                if(result.error())
                    console.error(result.error());
                else
                {
                  var creator = "";
                  // console.log(result.data());			
                  creator = result.data()[0]['NAME'] + " " + result.data()[0]['LAST_NAME'];	
                  this.fileList[index].innerDataHistory = [
                    {
                      key: 0,
                      fileName: file.NAME,
                      size: this.niceBytes(file.SIZE),
                      creator,
                      downloadedBy: creator,
                      dateDownload: this.moment(file.CREATE_TIME).format(
                        "YYYY-MM-DD HH:mm:ss"
                      ),
                      DOWNLOAD_URL: file.DOWNLOAD_URL,
                    },
                  ];		
                }
            });

     
    },
    addInnerData(index, file) {
      let netto = 0;
      let vat = 0;
      let {
        POZYCJE,
        ID_ZRODLA,
        NUMER,
        NAZWA1,
        WALUTA,
        DATA_WYSTAWIENIA,
        TERMIN,
      } = file;
      if (POZYCJE && POZYCJE.length) {
        let payments = POZYCJE[0].POZYCJA;
        for (let pay of payments) {
          netto += +pay.NETTO[0] || 0;
          vat += +pay.VAT[0] || 0;
        }
      }
      this.fileList[index].innerData.push({
        key: this.fileList[index].innerData.length,
        id: ID_ZRODLA[0],
        number: NUMER[0],
        contractor: NAZWA1[0],
        netto: +netto.toFixed(2),
        vat: +vat.toFixed(2),
        brutto: +(netto + vat).toFixed(2),
        currency: WALUTA[0],
        released: DATA_WYSTAWIENIA[0],
        term: TERMIN[0],
      });
    },
    downloadByLink(url) {
      var link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", "download");
      onload = link.click();
    },
  },
  updated() {
    BX24.fitWindow();
  },
  async mounted() {
    this.changeSpinning(true);

    let auth = BX24.getAuth();
    this.domain = auth.domain;
    let respGetExportTable = await getExportTable();
    if (respGetExportTable.ok) {
      let result = await respGetExportTable.json();

      this.setFileList(result.allFile);
    } else {
      this.$message.error(this.$t("Error loading files"));
    }
    this.changeSpinning(false);
    this.resizeFrame();
  },
};
</script>
